import React from 'react'
import { behallFokus } from '../tangentbord'

/**
 * StegKnappar – knappraden som avslutar varje steg i ett besöksflöde.
 *
 * Ligger alltid längst ned på SKÄRMEN, centrerad. `mt-auto` trycker ned raden när
 * innehållet är kortare än ytan, och `sticky bottom-0` håller den kvar när det är
 * längre. Bara sticky räckte inte: är innehållet kort finns inget att fastna mot,
 * och raden hamnade mitt på skärmen.
 *
 * Stegen är olika höga, så utan detta flyttade knapparna sig mellan varje steg och
 * handläggaren fick leta efter dem mitt i ett samtal.
 *
 * Ordningen är också fast: bakåt, framåt, avbryt.
 */

export interface StegKnapp {
  etikett: string
  onClick: () => void
  variant?: 'primar' | 'sekundar'
  disabled?: boolean
  /** Visas som tooltip, typiskt varför knappen är låst. */
  title?: string
}

/** Blå först när steget är klart – annars grå och låst. */
const primar =
  'rounded-sm bg-pejlen-500 px-5 py-2.5 text-base text-white transition-colors hover:bg-pejlen-400 disabled:cursor-not-allowed disabled:bg-gray-300'
const sekundar =
  'rounded-sm border border-gray-300 px-5 py-2.5 text-base text-gray-700 transition-colors hover:border-pejlen-400 disabled:cursor-not-allowed disabled:text-gray-400'

const StegKnappar: React.FC<{ knappar: StegKnapp[] }> = ({ knappar }) => (
  <div className="sticky bottom-0 z-10 mt-auto border-t border-gray-200 bg-white pb-2 pt-3">
    <div className="flex flex-wrap justify-center gap-2">
      {knappar.map((k) => (
        <button
          key={k.etikett}
          type="button"
          disabled={k.disabled}
          title={k.title ?? ''}
          // Utan detta stänger första trycket bara tangentbordet: blur flödar om
          // sidan innan klicket hinner landa på knappen. Se tangentbord.ts.
          onMouseDown={behallFokus}
          onClick={k.onClick}
          className={k.variant === 'primar' ? primar : sekundar}
        >
          {k.etikett}
        </button>
      ))}
    </div>
  </div>
)

export default StegKnappar
